import config from 'SRC/config/config.json'

export const groups = config.adForm.equipmentGroups
